import { svg } from "config/svgStyles";

export const optionsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
  paddingLeft: "10px",
  paddingRight: "10px",
  background: "white",
};

export const option = ({ isSelected }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  background: isSelected ? "primary" : "white",
  border: "solid 1px",
  borderColor: "grey5",
  borderRadius: "2px",
  height: "100%",
  paddingTop: "20px",
  paddingBottom: "20px",
  color: isSelected ? "white" : "text",
  flexGrow: "1",
  flexShrink: "1",
  flexBasis: "auto",
  cursor: "pointer",
  textAlign: "center",
  minWidth: "80px",
});

export const sharpnessBox = ({ isSelected }) => ({
  height: "40px",
  width: "40px",
  margin: "0 auto",
  mb: "5px",
  svg: svg(isSelected ? "white" : "grey9"),
});

export const sharpnessGuideSliderContainer = {
  display: "flex",
  flexDirecion: "row",
  justifyContent: "space-between",
  borderTop: "solid 2px",
  borderColor: "grey7",
  paddingTop: "20px",
  position: "relative",
  color: "grey5",

  "&:before": {
    content: '""',
    width: 0,
    height: 0,
    borderTop: "10px solid transparent",
    borderBottom: "10px solid transparent",
    borderLeft: "15px solid",
    borderRight: "10px solid transparent",
    borderLeftColor: "grey7",
    position: "absolute",
    right: 0,
    mr: "-12px",
    mt: "-31px",
  },

  "&:after": {
    content: '""',
    width: 0,
    height: 0,
    borderTop: "10px solid transparent",
    borderBottom: "10px solid transparent",
    borderLeft: "10px solid transparent",
    borderRight: "15px solid",
    borderRightColor: "grey7",
    position: "absolute",
    left: 0,
    ml: "-12px",
    mt: "-31px",
  },
};

export const sharpnessGuideTextContainer = {
  display: "flex",
  flexDirection: "column",
};

export const sharpnessGuideTextLeftSub = {
  color: "grey7",
};

export const sharpnessGuideTextRightSub = {
  color: "grey7",
  textAlign: "right",
};
